import { ClientApi } from 'api/ClientApi';
import { backendApiClient } from 'container/backendApiClient';

export const clientApi = new ClientApi(backendApiClient);
